import { createSlice } from '@reduxjs/toolkit';
import { ENUM__redux_action } from '../_base/ENUM__redux_action';
import { ENUM__redux_slice } from '../_base/ENUM__redux_slice';
import { LOCAL__global_reset } from '../_base/LOCAL__global_reset';
import { INIT_LOCAL__images_add_to_loading_pool } from './load/LOCAL__images_add_to_loading_pool';
import { INIT_REMOTE__images_load_by_hash_content } from './load/REMOTE__images_load_by_hash_content';
import { init_local_images_upsert_ai_description } from './local_images_upsert_ai_description';
import { init_remote_images_ai_description_create } from './remote_images_ai_description_create';
import { init_remote_images_ai_description_translate } from './remote_images_ai_description_translate';
import { STATE__images } from './STATE__images';
import { INIT_LOCAL__images_upsert } from './upsert_images/LOCAL__images_upsert';
import { INIT_LOCAL__images_upsert_meta } from './upsert_meta/LOCAL__images_upsert_meta_use';

const initialState: STATE__images = {
  //key - hash_sha256_content id
  images_map: new Map(),
  //key - id
  meta_map_by_id: new Map(),

  images_hashes_loading: new Set(),

  meta_map_by_hash_sha256_content: new Map(),

  ai_descriptions_map: new Map(),
  images_metadata_map: new Map(),
  ai_descriptions_translation_in_progress: new Set(),
  ai_descriptions_creating_in_progress: new Set(),
};

const reducers: Record<string, any> = {};
reducers[ENUM__redux_action.IMAGES_UPSERT_META.remove_first_part_of_path()] = INIT_LOCAL__images_upsert_meta;
reducers[ENUM__redux_action.IMAGES_ADD_TO_LOADING_POOL.remove_first_part_of_path()] = INIT_LOCAL__images_add_to_loading_pool;

export const slice_images = createSlice({
  name: ENUM__redux_slice.IMAGES,
  initialState,
  reducers: {
    ...reducers,
    upsert: INIT_LOCAL__images_upsert,
    ai_description_upsert: init_local_images_upsert_ai_description,
  },
  extraReducers: builder => {
    init_remote_images_ai_description_create(builder);
    init_remote_images_ai_description_translate(builder);
    INIT_REMOTE__images_load_by_hash_content(builder);

    builder.addCase(LOCAL__global_reset, state => {
      return initialState;
    });
  },
});
